import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OOCReport } from 'components/common/types/ProgrammaticCampaign.types';
import { ProgrammaticOOCState } from './reducer.types';

export const initialOOCReport: OOCReport = {
  campaigns: [],
  totalOocDealLineCount: 0,
  totalOocFrameCount: 0,
};

export const initialState: ProgrammaticOOCState = {
  oocReport: initialOOCReport,
};

export const programmaticOOCSlice = createSlice({
  name: 'programmaticOOC',
  initialState,
  reducers: {
    setCampaignsWithOOCFrames: (state, action: PayloadAction<OOCReport>) => {
      state.oocReport = action.payload;
    },
  },
});

export const { setCampaignsWithOOCFrames } = programmaticOOCSlice.actions;

export default programmaticOOCSlice.reducer;
